export const style = {
  wrapper: {
    position: 'relative',
    width: '100%',
    height: '100%',
    overflow: 'inherit',
    borderRadius: '8px',
    background: 'var(--default-white)',
    boxShadow: 'var(--box-shadow--1)',
    padding: '12px 0',
  },

  searchButton: {
    textTransform: 'inherit',
    width: '260px',

    svg: {
      width: '23px',
      height: '23px',
    },

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },

  tableContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: 'calc(100% - 46px)',

    '@media (max-width: 639.98px)': {
      paddingTop: '20px',
    },
  },

  container: {
    padding: '0 16px',
  },

  table: {
    maxWidth: '1087px',
    tableLayout: 'fixed',
  },

  tableHeader: {
    '& > :nth-of-type(1)': {
      width: '10%',
      textTransform: 'capitalize',
      whiteSpace: 'nowrap',

      '@media (max-width: 1199.98px)': {
        whiteSpace: 'normal',
      },

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(2)': {
      width: '14%',

      '@media (max-width: 767.98px)': {
        width: '44%',
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
      },

      '& .MuiTableSortLabel-icon': {
        '@media (max-width: 767.98px)': {
          display: 'none',
        },
      },
    },

    '& > :nth-of-type(3)': {
      width: '10%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(4)': {
      width: '15%',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(5)': {
      width: '15%',
    },
    '& > :nth-of-type(6)': {
      width: '11%',

      '@media (max-width: 767.98px)': {
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
        width: '15%',
      },
    },
    '& > :nth-of-type(7)': {
      width: '6%',
      textTransform: 'uppercase',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
  },

  tableBody: {
    '& > :nth-of-type(1)': {
      fontSize: '12px',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },

    '& > :nth-of-type(3)': {
      fontSize: '12px',

      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(4)': {
      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },
    '& > :nth-of-type(5)': {},

    '& > :nth-of-type(4) .MuiBox-root': {
      '& > .MuiTypography-root:nth-of-type(1)': {
        fontWeight: 700,
      },
      '& > .MuiTypography-root:nth-of-type(2)': {
        fontSize: '12px',
        color: 'var(--neutral-300)',
      },
    },

    '& > :nth-of-type(6) .MuiBox-root': {
      '& > .MuiTypography-root:nth-of-type(1)': {
        fontWeight: 700,
      },
      '& > .MuiTypography-root:nth-of-type(2)': {
        fontSize: '12px',
        color: 'var(--neutral-300)',
      },
    },

    '& > :nth-of-type(7)': {
      textAlign: 'right',
      '@media (max-width: 767.98px)': {
        display: 'none',
      },
    },

    '& .MuiTableCell-root': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      height: '42px',
      paddingTop: '8px !important',
      paddingBottom: '8px !important',
    },
  },

  status: {
    '&.MuiTypography-root svg': {
      // marginLeft: '4px',
    },
  },

  menuItem: {
    width: '100%',
    padding: '8px 16px',
    cursor: 'pointer',

    '&:hover': {
      backgroundColor: 'var(--background-grey-op-50-1)',
    },
  },

  hideMenuItem: {
    display: 'none',
  },

  detailsModal: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      padding: '48px 38px 0 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px',
    },
  },

  profilePage: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      maxHeight: 'calc(100% - 48px)',
      height: '100%',
      padding: '48px 38px 0 48px',
      scrollbarGutter: 'stable',
      margin: '0 15px',
      borderRadius: '8px 8px 0 0',
    },

    '&.MuiDialog-root': {
      height: 'calc(100% - 80px)',
    },
  },

  loader: {
    position: 'absolute',
    left: 'calc(50% - 25px)',
    top: '200px',
  },

  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginRight: '16px',
    marginBottom: '12px',

    '@media (max-width: 1199.98px)': {
      display: 'none',
    },
  },

  modal: {
    '.MuiPaper-root': {
      position: 'relative',
      maxWidth: '1170px',
      width: '100%',
      height: 'calc(100% - 48px)',
      padding: '48px 48px 0 48px',
      margin: '0 15px',
      borderRadius: '8px',
    },
  },

  emptyTable: {
    borderBottom: 'none',
    textAlign: 'center',
    '& .MuiTypography-root': {
      fontSize: '18px !important',
      fontWeight: '700 !important',
    },

    fontSize: '18px !important',
    fontWeight: '700 !important',
  },

  containerWrapper: {
    height: '100%',
    position: 'relative',
    minHeight: 'calc(100vh - 148px)',
    maxHeight: 'fit-content',

    '@media (min-width: 1200px)': {
      minHeight: 'calc(100vh - 128px)',
    },
  },
};
